import fontawesome from '@fortawesome/fontawesome';
import faFacebookSquare from '@fortawesome/fontawesome-free-brands/faFacebookSquare';
import faGooglePlusSquare from '@fortawesome/fontawesome-free-brands/faGooglePlusSquare';
import faLinkedin from '@fortawesome/fontawesome-free-brands/faLinkedin';
import faPinterestSquare from '@fortawesome/fontawesome-free-brands/faPinterestSquare';
import faTwitterSquare from '@fortawesome/fontawesome-free-brands/faTwitterSquare';
import faYoutubeSquare from '@fortawesome/fontawesome-free-brands/faYoutubeSquare';
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram';

fontawesome.config = {
  keepOriginalSource: false,
};

fontawesome.library.add(
  faFacebookSquare,
  faGooglePlusSquare,
  faLinkedin,
  faPinterestSquare,
  faTwitterSquare,
  faYoutubeSquare,
  faInstagram,
);
